/**
 * @file 学籍验证API
 * @author 小白
 */

import request from "@/utils/request";
import { queryParams as qp } from "@/utils/function.js";

// 获取滑块验证码
export async function getAuthenticationSlider(data) {
  return request.get("/authentication/slider", data);
}

// 发送短信验证码
export async function sendSmsCaptcha(data) {
  return request.post("/openApi/studentAccount/sms/captcha", data);
}

// 获取手机号短信
export async function postAuthPhoneNumber(data) {
  return request.post("/authentication/authPhoneNumber", data);
}

// 绑定手机号
export async function postAuthenticationPhoneNumber(data) {
  return request.post("/authentication/authenticationPhoneNumber", data);
}

// 获取实名认证token
export async function verifyToken(data) {
  return request.get(`/authentication/verifyToken${qp(data)}`);
}

// 获取实名认证结果
export async function facePrintDetail(data) {
  return request.get(`/authentication/facePrintDetail${qp(data)}`);
}

// 获取已签约协议详情
export async function getMajorBatchAgreement(data) {
  return request.get(`/majorBatch/getMajorBatchAgreement${qp(data)}`);
}

// 签约
export async function generatingSignatureProtocol(data) {
  return request.post(`/majorBatch/generatingSignatureProtocol`, data);
}

// 获取学籍信息
export async function getAtuPreapply(data) {
  return request.get(`/authentication/stuPreapply`, data);
}

// 获取签约协议
export async function getAgreement(data) {
  return request.get(`/authentication/agreement`, data);
}

// 获取学员是否存在支付订单
export async function findPayment(data) {
  return request.get(`/payment/findPayment`, data);
}

// 获取支付订单详情（未支付和已支付同一接口）
export async function getOrderQueryDetail(data) {
  return request.get(`/payment/queryDetail${qp(data)}`);
}

// 获取支付订单是否已支付完成
export async function getOrderPayStatus(data) {
  return request.get(`/payment/status${qp(data)}`);
}

// 测试支付接口
export async function testPay(data) {
  return request.post(`/payment/testPay`, data);
}

// 查询用户当前授权阶段
export async function getStudentQueryStage() {
  return request.get(`/authentication/queryStage`);
}


// 发送短信验证码
export async function resetPassword(data) {
  return request.post("/openApi/studentAccount/updatePassword", data);
}
